import React from 'react'
import styles from '../ColorsControlSection/ColorsControl.module.scss'
import { useMatrixFilterColor } from '../../../../../hooks/useMatrixFilterColor'
import { useActions } from '../../../../../hooks/useActions'

const PreviewColorLine = ({
	renderData,
	currentPreset,
	header = '',
	text = '',
	property,
	preset,
	type,
	isClassName = true,
}) => {
	const getFillColor = useMatrixFilterColor()
	const { setPresetProperty } = useActions()

	let flatData = renderData.map(([_, value]) => value)

	if (property === 'actions') {
		flatData = renderData.map(([_, value]) => value).flat()
	}

	if (property === 'range') {
		flatData = []

		for (let i = 0; i < 5; i++) {
			const rangeGradientColor = getFillColor({
				field: 'abs',
				played: (i * 25) / 100,
				matrixRange: preset.matrix.range,
				matrixEquity: preset.matrix.equity,
				matrixEv: preset.matrix.ev,
				matrixEqr: preset.matrix.eqr,
			})

			flatData.push(rangeGradientColor)
		}
	}

	const className = currentPreset === header ? styles.applyFormRowSelected : styles.applyFormRow

	const setOptions = () => {
		setPresetProperty({ preset, type, property })
	}

	return (
		<div
			className={isClassName ? className : styles.presetViewRow}
			style={{
				width: '100%',
				height: isClassName ? '' : '22px',
				borderRadius: isClassName ? '' : '2px',
				cursor: 'pointer',
			}}
			onClick={setOptions}
		>
			{flatData.map((value, index) => {
				return (
					<div
						style={{
							backgroundColor: value,
							width: `calc(100% / ${flatData.length})`,
							height: '20px',
						}}
						className={styles.colorfulSquare}
						key={index}
					>
						{text ? <span style={{ textAlign: 'center', fontSize: 17, fontWeight: 500 }}>{text}</span> : null}
					</div>
				)
			})}
		</div>
	)
}

export default PreviewColorLine
